var _path, _path2, _g, _rect, _rect2, _rect3, _rect4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 431,
    viewBox: "0 0 512 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384 111H462C471.941 111 480 119.059 480 129V381C480 390.941 471.941 399 462 399H50C40.0589 399 32 390.941 32 381V129C32 119.059 40.0589 111 50 111H128V79H50C22.3858 79 0 101.386 0 129V381C0 408.614 22.3858 431 50 431H462C489.614 431 512 408.614 512 381V129C512 101.386 489.614 79 462 79H384V111Z",
    fill: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_105_45",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 117,
    width: 226,
    height: 224
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354 229C354 281.886 310.706 325 257 325C203.294 325 160 281.886 160 229C160 176.114 203.294 133 257 133C310.706 133 354 176.114 354 229Z",
    stroke: "black",
    strokeWidth: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_105_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 253,
    width: 276,
    height: 88,
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 117,
    width: 276,
    height: 96,
    fill: "#2C2C2C"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 359.915,
    y: 240.979,
    width: 24,
    height: 60,
    rx: 12,
    transform: "rotate(-149.878 359.915 240.979)",
    fill: "#2C2C2C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 372.092,
    y: 220.098,
    width: 24,
    height: 60,
    rx: 12,
    transform: "rotate(120.122 372.092 220.098)",
    fill: "#2C2C2C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 162.549,
    y: 223.073,
    width: 24,
    height: 60,
    rx: 12,
    transform: "rotate(35.1222 162.549 223.073)",
    fill: "#2C2C2C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148.598,
    y: 242.814,
    width: 24,
    height: 60,
    rx: 12,
    transform: "rotate(-54.8778 148.598 242.814)",
    fill: "#2C2C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 102.5L164.049 18.4606C164.948 16.9358 166.586 16 168.356 16H344.615C346.4 16 348.05 16.952 348.944 18.4978L397.5 102.5",
    stroke: "#2C2C2C",
    strokeWidth: 32
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCameraIcon);
export default __webpack_public_path__ + "static/media/switch-camera-icon.b2300680f155369d4d7e62dccdf3fab4.svg";
export { ForwardRef as ReactComponent };